// AdSense-ready ad slot. Renders a labelled placeholder when publisher ID is missing.
import { useEffect, useRef } from "react";
import { useT } from "@/lib/i18n";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;

export default function AdSlot({ slot, format = "auto", className = "", testId = "ad-slot" }) {
  const ref = useRef(null);
  const t = useT();

  useEffect(() => {
    if (!CLIENT || !slot) return;
    try {
      // eslint-disable-next-line no-undef
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.error("AdSlot push failed", err);
    }
  }, [slot]);

  if (!CLIENT || !slot) {
    return (
      <div
        ref={ref}
        data-testid={testId}
        className={`w-full min-h-[90px] rounded-md border border-dashed border-border bg-muted/40 flex items-center justify-center text-[10px] uppercase tracking-[0.2em] text-muted-foreground ${className}`}
      >
        {t("ad_placeholder")} · Slot {slot || "auto"}
      </div>
    );
  }

  return (
    <ins
      className={`adsbygoogle ${className}`}
      style={{ display: "block" }}
      data-ad-client={CLIENT}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
      data-testid={testId}
    />
  );
}
